import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { Concept, Project } from 'lib/types/projects';
import {
  Avatar, MenuItem, Select, DialogActions,
} from '@mui/material';
import { useState, useEffect } from 'react';
import { useApplicationState } from 'lib/contexts/ApplicationState';

interface Props {
  concept: Concept;
  teamId: number;
  onCancel: () => void;
  onDuplicate: (arg: any) => void;
}

export const DuplicateConceptModal = ({
  onCancel, onDuplicate, concept, teamId,
}: Props) => {
  const [projects, setProjects] = useState<Project[]>([]);
  const [pId, setPId] = useState<number|null|undefined>(concept?.projectId);
  const [newProjectName, setNewProjectName] = useState<string | undefined>();

  const { api, currentUser } = useApplicationState();

  useEffect(() => {
    const getProjects = async () => {
      const p = await api.getProjects(teamId);
      setProjects(p);
    };

    if (currentUser && teamId) getProjects();
  }, [currentUser, teamId]);

  return (
    <Dialog open fullWidth>
      <div className="p-6">
        <div>
          <h1 className="text-lg font-semibold">Duplicate concept</h1>
          <div className="absolute right-2 top-2">
            <IconButton onClick={onCancel}>
              <CloseIcon />
            </IconButton>
          </div>
        </div>
        <div className="py-4">
          {projects && (
            <div className=" gap-2 items-center mb-4">
              <div className="font-bold mb-2">Select a project to duplicate this concept to:</div>
              <div className="w-full text-black dark:text-white">
                <Select
                  size="small"
                  onChange={(e) => setPId(Number(e.target.value))}
                  value={pId}
                >
                  {projects?.map((p) => (
                    <MenuItem key={p.id} value={p.id}>
                      <div className="flex items-center gap-2">
                        {p.clients && (p.clients?.length || 0) > 0 && (
                          <Avatar src={p.clients[0].avatarUrl} alt={p.clients[0].name} sizes="small" />
                        )}
                        <div className="font-semibold">
                          {p.name}
                        </div>
                      </div>
                    </MenuItem>
                  ))}
                  <MenuItem value={0}>
                    <div className="flex items-center gap-2">
                      <Avatar sizes="small" sx={{ bgcolor: '#F76F4A' }}>+</Avatar>
                      <div className="font-semibold">
                        Create a new project
                      </div>
                    </div>
                  </MenuItem>
                </Select>
              </div>
            </div>
          )}
          {pId === 0 && <input type="text" placeholder="Project title" className="w-full p-2 rounded-lg border border-mediumgray" onChange={(e) => setNewProjectName(e.target.value)} />}
        </div>
        <DialogActions>
          <button type="button" className="btn-primary-outlined mr-2" onClick={onCancel} color="inherit">
            Cancel
          </button>
          <button type="button" className="btn-primary" onClick={() => onDuplicate({ projectId: pId, name: newProjectName })} color="primary" disabled={!pId && !newProjectName}>
            Save
          </button>
        </DialogActions>
      </div>
    </Dialog>
  );
};
